(() => {
  const THRESHOLD = 7500; // cents (75€)
  const selectors = {
    root: '.jm-free-ship',
    bar: '.jm-progress__bar',
    text: '.jm-free-ship__text'
  };

  function formatMoney(cents) {
    // Shopify Money Format falls vorhanden:
    const fmt = window?.Shopify?.money_format || "{{amount}} €";
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, fmt);
    }
    // Fallback:
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  async function updateBars() {
    const roots = document.querySelectorAll(selectors.root);
    if (!roots.length) return;

    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();

    const total = cart.total_price;
    const remaining = Math.max(0, THRESHOLD - total);
    const progress = Math.min(100, Math.round((total / THRESHOLD) * 100));

    roots.forEach(root => {
      const bar = root.querySelector(selectors.bar);
      const text = root.querySelector(selectors.text);

      if (bar) bar.style.setProperty('--jm-progress', `${progress}%`);

      if (text) {
        text.innerHTML = remaining > 0
          ? `Nur noch <strong>${formatMoney(remaining)}</strong> bis zum kostenlosen Versand.`
          : `<strong>Kostenloser Versand</strong> freigeschaltet.`;
      }
    });
  }

  // Initial
  document.addEventListener('DOMContentLoaded', updateBars);

  // Dawn cart updates via change / clicks → update after interactions
  document.addEventListener('change', (e) => {
    if (e.target.closest('cart-items, .cart-items, .cart__contents')) {
      setTimeout(updateBars, 350);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('cart-items, .cart-items, .cart__contents')) {
      setTimeout(updateBars, 350);
    }
  });

  // If sections replace DOM, keep it in sync
  const mo = new MutationObserver(() => updateBars());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();